// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ppwT","questions":"styles_questions__3elU3","footer":"styles_footer__2isvE"};